import {
  DefaultApi, Configuration, ConfigurationParameters,
} from '../generated-api';

const defaultBasePath =
  (window as { __limberApiBasePath?: string }).__limberApiBasePath
  || `${window.location.protocol}//${window.location.host}`;

export default class LimberAdminApi extends DefaultApi {
  constructor(params: Partial<ConfigurationParameters>) {
    const { accessToken } = params;
    super(new Configuration({
      basePath: defaultBasePath,
      ...params,
      accessToken: accessToken == null ? undefined : `Bearer ${accessToken}`,
    }));
  }
}
